/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_Appname1Inputs */

const id_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Aplikasi`)
};

const ms_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama Apl`)
};

const da_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App navn`)
};

const de_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Name`)
};

const en_us2_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Name`)
};

const es_es2_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de app`)
};

const es_mx2_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la app`)
};

const fil_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangalan ng App`)
};

const fr_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l'application`)
};

const it_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome app`)
};

const hu_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkalmazás neve`)
};

const nl_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-naam`)
};

const no_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-navn`)
};

const pl_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwa aplikacji`)
};

const pt_br2_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do aplicativo`)
};

const pt_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da app`)
};

const ro_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nume aplicație`)
};

const fi_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovelluksen nimi`)
};

const sv_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-namn`)
};

const vi_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên ứng dụng`)
};

const tr_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama Adı`)
};

const cs_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název aplikace`)
};

const bg_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Име на приложение`)
};

const ru_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя приложения`)
};

const uk_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва застосунку`)
};

const ar_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم التطبيق`)
};

const hi_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐप नाम`)
};

const th_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อแอป`)
};

const ja_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリ名`)
};

const zh_cn2_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用名称`)
};

const zh_hant1_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`應用程式名稱`)
};

const ko_builds_table_appname1 = /** @type {(inputs: Builds_Table_Appname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱 이름`)
};

/**
* | output |
* | --- |
* | "App Name" |
*
* @param {Builds_Table_Appname1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_appname1 = /** @type {((inputs?: Builds_Table_Appname1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_Appname1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_appname1(inputs)
	if (locale === "ms") return ms_builds_table_appname1(inputs)
	if (locale === "da") return da_builds_table_appname1(inputs)
	if (locale === "de") return de_builds_table_appname1(inputs)
	if (locale === "en-US") return en_us2_builds_table_appname1(inputs)
	if (locale === "es-ES") return es_es2_builds_table_appname1(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_appname1(inputs)
	if (locale === "fil") return fil_builds_table_appname1(inputs)
	if (locale === "fr") return fr_builds_table_appname1(inputs)
	if (locale === "it") return it_builds_table_appname1(inputs)
	if (locale === "hu") return hu_builds_table_appname1(inputs)
	if (locale === "nl") return nl_builds_table_appname1(inputs)
	if (locale === "no") return no_builds_table_appname1(inputs)
	if (locale === "pl") return pl_builds_table_appname1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_appname1(inputs)
	if (locale === "pt") return pt_builds_table_appname1(inputs)
	if (locale === "ro") return ro_builds_table_appname1(inputs)
	if (locale === "fi") return fi_builds_table_appname1(inputs)
	if (locale === "sv") return sv_builds_table_appname1(inputs)
	if (locale === "vi") return vi_builds_table_appname1(inputs)
	if (locale === "tr") return tr_builds_table_appname1(inputs)
	if (locale === "cs") return cs_builds_table_appname1(inputs)
	if (locale === "bg") return bg_builds_table_appname1(inputs)
	if (locale === "ru") return ru_builds_table_appname1(inputs)
	if (locale === "uk") return uk_builds_table_appname1(inputs)
	if (locale === "ar") return ar_builds_table_appname1(inputs)
	if (locale === "hi") return hi_builds_table_appname1(inputs)
	if (locale === "th") return th_builds_table_appname1(inputs)
	if (locale === "ja") return ja_builds_table_appname1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_appname1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_appname1(inputs)
	return ko_builds_table_appname1(inputs)
});
export { builds_table_appname1 as "builds.table.appName" }